import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import RoleRender from "../../RoleRender/RoleRender";
import {UserRoles} from "../../../common/Constants";
import TimeAgo from "../../../common/TimeAgo";
import CurrencyLabel from "../../CurrencyLabel/CurrencyLabel";

const ExtraHeight = 50;

const Styles = {

    frame: {
        backgroundColor: "#ececec",
        borderRadius: 8,
        padding: 10,
        marginTop: 5
    },

    header: {
        fontSize: 14
    }
};

class TractorRequest extends  React.Component {

    static propTypes = {
        notification: PropTypes.object,
        services: PropTypes.array,
        onDelete: PropTypes.func
    };

    constructor(props){
        super(props);

        this.state = {

            //  show full detail
            showMore: false,

            //  set ussd services
            services:  props.services,

            //
            tractorRequest: null,

            //
            service: null
        };

    }

    getServiceName(id){

        const frame =  this.state.services.find(x => x.id == id);

        if(frame){
            return frame.name;
        }

        return "Unknown";
    }

    renderSimple(notification){

        const request = notification.metadata.TractorRequest;

        return (<div style={Styles.frame}>

            <div className="clearfix">

                <div className="pull-left">
                    <b style={Styles.header}>Request Details</b>
                </div>

                <div className="pull-right">

                    <Button color="link" onClick={() =>{

                        this.setState({
                            showMore: true
                        });

                    }}><i className="fa fa-arrow-down"></i> Show More</Button>

                </div>

            </div>

            <dl>

                <dt>Name</dt>
                <dd>{request.name}</dd>

                <dt>Cost</dt>
                <dd><CurrencyLabel value={request.cost}/></dd>
            </dl>


        </div>);

    }


    renderFull(notification){

        const request = notification.metadata.TractorRequest;

        return <div style={Styles.frame}>
            <div className="clearfix">

                <div className="pull-left">
                    <b style={Styles.header}>Request Details</b>
                </div>

                <div className="pull-right">

                    <Button color="link" onClick={() =>{

                        this.setState({
                            showMore: false
                        });

                    }}><i className="fa fa-arrow-up"></i> Show Less</Button>

                </div>

            </div>

            <dl>
            <dt>Name</dt>
            <dd>{request.name}</dd>

            <dt>Cost</dt>
            <dd><CurrencyLabel value={request.cost}/></dd>

            <dt>Service Type</dt>
            <dd>{this.getServiceName(request.service_id)}</dd>

            <RoleRender role={UserRoles.Admin}>
                <div>
                    <dt>Phone</dt>
                    <dd>{request.phone}</dd>
                </div>
            </RoleRender>

            <dt>Location</dt>
            <dd>{request.location}</dd>

            {request.service ? <React.Fragment>
                <dt>Total {request.service.unit_name}(s)</dt>
                <dd>{request.hectares}</dd>
            </React.Fragment> : <React.Fragment>
                <dt>Total Hectare(s)</dt>
                <dd>{request.hectares}</dd>
            </React.Fragment>}

            <RoleRender role={UserRoles.Admin}>
                <div>
                    <dt>Time Requested</dt>
                    <dd><TimeAgo id={`req_${request.id}_date_created`} date={request.date_created} /></dd>
                </div>
            </RoleRender>

            </dl>

            <div className="clearfix">

                <div className="pull-left">
                    <a className="btn-link" href={`/requests?filter_id=${request.id}&q=${request.order_id}`}>Click to see</a>
                </div>

                <div className="pull-right">
                    <TimeAgo id={`notif_${request.id}_date_created`} date={notification.date_created}/>
                </div>

            </div>
        </div>
    }

    render(){

        const props = this.props;
        const notification = props.notification;

        return <div style={{fontSize: "small" , marginBottom: 10}}>

            <div className="clearfix">

                <b style={{fontSize: 16 , color: "#2d2d2d"}} className="pull-left"><i></i> {notification.title}</b>

                {props.onDelete && <div className="pull-right">
                    <Button onClick={props.onDelete} size="sm" color={"danger"} outline={true} style={{ borderRadius: 4 }}><i className="fa fa-trash"></i> Remove</Button>
                </div>}

            </div>

                {this.state.showMore ? this.renderFull(notification) : this.renderSimple(notification)}
            </div>;

    }

}

export default TractorRequest;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/Templates/TractorRequest.js